import { AdmDataGrid } from "@components/common/data-grid/adm-data-grid";
import { useMemberWorkspacesTableColumns } from "@pages/member-profile/tab-contents/member-workspace-tab/use-member-workspaces-table-columns";
import { ContentLayout } from "@pages/content-layout";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { useAppNavigation } from "@router/use-app-navigation";

interface Props {
  /** List of companies that a member has role within it */
  companies: FaroCoreApiTypes.AdmUserCompany[];
}

/** Shows a list of companies that a member has role within it in a table */
export function MemberWorkspaces({ companies }: Props): React.JSX.Element {
  const { navigateToProfilePage } = useAppNavigation();
  const columns = useMemberWorkspacesTableColumns();

  return (
    <ContentLayout contentSx={{ overflowY: "hidden" }}>
      <AdmDataGrid
        entities={companies}
        uniqueIdKey="id"
        tableType="member-workspaces-table"
        columns={columns}
        // Data is coming from somewhere else with error handling. So no need to show error in here.
        errorMessage=""
        shouldShowErrorMessage={false}
        onRowClick={(companyId) =>
          navigateToProfilePage({
            subjectType: "COMPANY",
            subjectId: companyId,
          })
        }
      />
    </ContentLayout>
  );
}
